import { render, staticRenderFns } from "./new-batch.vue?vue&type=template&id=6b0e94d2"
import script from "./new-batch.vue?vue&type=script&lang=js"
export * from "./new-batch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports